// extracted by mini-css-extract-plugin
export var borderRadius = "_72-4";
export var large = "_72-3";
export var logoContainer = "_72-0";
export var nameLogo = "_72-2";
export var small = "_72-1";